module.exports = __webpack_public_path__ + "img/loading-bubbles.7ef88d2a.svg";